<router-outlet></router-outlet>

<ngx-spinner [name]="'external-spinner'" [type]="'square-jelly-box'"></ngx-spinner>